import { render, staticRenderFns } from "./SharedContentTable.vue?vue&type=template&id=35c057d9&scoped=true&"
import script from "./SharedContentTable.vue?vue&type=script&lang=js&"
export * from "./SharedContentTable.vue?vue&type=script&lang=js&"
import style0 from "./SharedContentTable.vue?vue&type=style&index=0&id=35c057d9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35c057d9",
  null
  
)

export default component.exports